const attemptTime = history => Date.parse(history?.lastAttemptAt);
export const mergeTicketHistory = (current, incoming) => {
  if (!incoming) return current;
  if (!current) return incoming;
  const previousAttempt = attemptTime(current);
  const incomingAttempt = attemptTime(incoming);
  if (Number.isFinite(previousAttempt) && !Number.isFinite(incomingAttempt)) return current;
  if (Number.isFinite(previousAttempt) && Number.isFinite(incomingAttempt)) {
    if (incomingAttempt < previousAttempt) return current;
    if (incomingAttempt === previousAttempt && current.status !== "syncing" && incoming.status === "syncing") return current;
  }
  return incoming;
};

export const historyStatusTitle = status => ({
  syncing: "Buscando histórico disponível…",
  available: "Histórico disponível",
  partial: "Histórico parcialmente disponível",
  unavailable: "O WhatsApp não disponibilizou o histórico",
  failed: "Não foi possível atualizar o histórico",
})[status] || "Histórico da conversa";

export const historyRefreshKey = history => [history?.lastAttemptAt || "", history?.status || "", history?.imported || 0].join(":");
